<template>
<div class="chapter">
<div class="inner_page">
<div>
<a id="page_iii"></a>
<h2 class="fronttitle" id="heading_id_2">CONTENTS</h2>
<p class="toc1"><a class="sgc-1" href="#/Text/preface">Preface</a></p>
<p class="toc"><a href="#/Text/chapter01">CHAPTER 1     12 September 1944</a></p>
<p class="toc"><a href="#/Text/chapter02">CHAPTER 2      VII Corps Breaches the <i>Westwall</i></a></p>
<p class="toc"><a href="#/Text/chapter03">CHAPTER 3     Penetrating the Schill Line</a></p>
<p class="toc"><span href="#/Text/chapter04" title="Link target outside of Sample">CHAPTER 4     Stalemate at Stolberg</span></p>
<p class="toc"><span href="#/Text/chapter05" title="Link target outside of Sample">CHAPTER 5     XIX Corps Crosses the Wurm River</span></p>
<p class="toc"><span href="#/Text/chapter06" title="Link target outside of Sample">CHAPTER 6     XIX Corps Breaks through the <i>Westwall</i></span></p>
<p class="toc"><span href="#/Text/chapter07" title="Link target outside of Sample">CHAPTER 7     XIX Corps Widens the Bridgehead</span></p>
<p class="toc"><span href="#/Text/chapter08" title="Link target outside of Sample">CHAPTER 8     South toward Alsdorf</span></p>
<p class="toc"><span href="#/Text/chapter09" title="Link target outside of Sample">CHAPTER 9     Verlautenheide, Crucifix Hill, and the Ravelsberg Fall</span></p>
<p class="toc"><span href="#/Text/chapter10" title="Link target outside of Sample">CHAPTER 10     Ultimatum and the First Attacks on Aachen</span></p>
<p class="toc"><span href="#/Text/chapter11" title="Link target outside of Sample">CHAPTER 11     The Northern Jaw</span></p>
<p class="toc"><span href="#/Text/chapter12" title="Link target outside of Sample">CHAPTER 12     The Gap Closes</span></p>
<p class="toc"><span href="#/Text/chapter13" title="Link target outside of Sample">CHAPTER 13     Surrender</span></p>
<p class="toc1"><span href="#/Text/afterword" title="Link target outside of Sample">Afterword</span></p>
<p class="toc1"><span class="sgc-1" href="#/Text/notes" title="Link target outside of Sample">Notes</span></p>
<p class="toc1"><span class="sgc-1" href="#/Text/bibliography" title="Link target outside of Sample">Bibliography</span></p>
<p class="toc1"><span class="sgc-1" href="#/Text/acknowledgments" title="Link target outside of Sample">Acknowledgments</span></p>
<p class="toc1"><span class="sgc-1" href="#/Text/index" title="Link target outside of Sample">Index</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?4d8e0405